import common from './common.json';
import errors from './errors.json';
import glossary from './glossary.json';
import items from './items.json';
import login from './login.json';
import pm from './pm.json';
import settings from './settings.json';

export { common, items, glossary, login, settings, errors, pm };
